export function parsePublicationDate(value) {
  const utcValue = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(value) ? `${value}Z` : value;
  return new Date(utcValue);
}

// "" for a missing or unreadable date, rather than "Invalid Date UTC".
export function publicationTime(value) {
  const date = value == null || value === "" ? null : parsePublicationDate(value);
  if (!date || Number.isNaN(date.getTime())) return "";
  return `${date.toLocaleString("en-GB", { dateStyle: "medium", timeStyle: "short", timeZone: "UTC" })} UTC`;
}
